export function tabs() {
    const tabsWidgets = document.querySelectorAll('.tabs .tabs-container');
    if (!tabsWidgets.length)
        return;
    tabsWidgets.forEach(widget => {
        initializeLists(widget);
    });
    function initializeLists(widgetContainer) {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const currentSlug = decodeURI(urlSearchParams.get('tab'));
        if (currentSlug != 'null') {
            const element = document.querySelector('[data-item-slug="' + currentSlug + '"]');
            if (element) {
                element.closest('.tabs-container').scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
        const sidebarItems = widgetContainer.querySelectorAll('.sidebar-item');
        const tabsItems = widgetContainer.querySelectorAll('.tabs-item');
        const backButtons = widgetContainer.querySelectorAll('.item-back');
        sidebarItems.forEach(sidebarItem => {
            const listId = sidebarItem.getAttribute('data-list-id');
            const itemId = sidebarItem.getAttribute('data-item-id');
            const itemSlug = sidebarItem.getAttribute('data-item-slug');
            sidebarItem.addEventListener('click', () => {
                sidebarItems.forEach(item => item.classList.remove('active'));
                tabsItems.forEach(tab => tab.classList.remove('active'));
                sidebarItem.classList.add('active');
                if (history.pushState) {
                    urlSearchParams.set('tab', itemSlug);
                    let queryString = '?' + urlSearchParams;
                    let url = window.location.protocol + "//" + window.location.host + window.location.pathname;
                    history.replaceState(undefined, undefined, url + queryString);
                }
                const activeContainer = widgetContainer.querySelector(`.tabs-item[data-list-id="${listId}"][data-item-id="${itemId}"]`);
                if (activeContainer) {
                    activeContainer.classList.add('active');
                    widgetContainer.classList.add('active');
                }
            });
        });
        backButtons.forEach(backButton => {
            backButton.addEventListener('click', () => {
                tabsItems.forEach(tab => tab.classList.remove('active'));
                sidebarItems.forEach(item => item.classList.remove('active'));
                widgetContainer?.classList.remove('active');
            });
        });
    }
}
